export default __webpack_public_path__ + "static/style2.3_Elena-2eaae638f73202833ff15d65b77f77ab.wav";